// extracted by mini-css-extract-plugin
module.exports = {"field":"TransferTokenModalForm_field__2jM-j","buttonContainer":"TransferTokenModalForm_buttonContainer__1_WCt","sending":"TransferTokenModalForm_sending__3Azrb"};